export const profiles = {
  ADMINISTRADOR: 1,
  COORDENADOR_DOCENTE: 2,
  COORDENADOR_DISCENTE: 3,
  MONITOR_VOLUNTARIO: 4,
  MONITOR_BOLSISTA: 5,
  EDUCANDO: 6,
  USUARIO_EXTERNO: 7,
};

export const profilesOptions = [
  {
    text: 'Administrador',
    value: 1,
  },
  {
    text: 'Coordenador Docente',
    value: 2,
  },
  {
    text: 'Coordenador Discente',
    value: 3,
  },
  {
    text: 'Monitor Voluntário',
    value: 4,
  },
  {
    text: 'Monitor Bolsista',
    value: 5,
  },
  {
    text: 'Educando',
    value: 6,
  },
  {
    text: 'Usuário Externo',
    value: 7,
  },
];
